<template>
  <div class="table-responsive">
    <p>
      Segue abaixo a exibição do histórico de logs de clientes com a omie.
      Cada linha é uma fatura com a sua última tentativa; clique para ver
      todas as tentativas.
    </p>
    <div class="d-flex justify-content-between align-items-center mb-3">
      <div class="form-inline">
        <label class="mr-2"><strong>Filtrar por:</strong></label>
        <select class="form-control" v-model="status" @change="onFilterChange">
          <option value="2">Erro</option>
          <option value="1">Sucesso</option>
          <option value="6">Aguardando faturamento</option>
          <option value="7">Aguardando NFS-e</option>
          <option value="all">Todos</option>
        </select>
      </div>
      <button
        v-if="omieAlerts.email > 0"
        class="btn btn-sm btn-outline-brand"
        @click="markAsSeen()"
      >
        <i class="fas fa-check"></i> Marcar alertas como vistos ({{ omieAlerts.email }})
      </button>
    </div>
    <div class="container-table">
      <table class="table table-bordered">
        <thead>
          <tr>
            <th nowrap class="text-center"></th>
            <th nowrap class="text-center">Enviado Por</th>
            <th nowrap class="text-center">ID Fatura</th>
            <th nowrap class="text-center">ID Cliente</th>
            <th nowrap class="text-center">Produto</th>
            <th nowrap class="text-center">Mês Fatura</th>
            <th nowrap class="text-center">Status</th>
            <th nowrap class="text-center">Último Log</th>
            <th nowrap class="text-center">Tentativas</th>
            <th nowrap class="text-center">Última Tentativa</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="invoice in data.data">
            <tr
              class="clickable pointer"
              :key="invoice.id"
              @click="toggleInvoice(invoice.id)"
            >
              <td class="text-center">
                <i
                  class="fas"
                  :class="isExpanded(invoice.id) ? 'fa-chevron-down' : 'fa-chevron-right'"
                ></i>
              </td>
              <td class="text-center">{{ invoice.username || '-' }}</td>
              <td class="text-center">{{ invoice.id }}</td>
              <td class="text-center">{{ invoice.customer_id }}</td>
              <td class="text-center">{{ invoice.name }}</td>
              <td class="text-center">{{ invoice.billing_month | date }}</td>
              <td class="text-center">
                <span class="badge" :class="statusBadge(invoice.status)">
                  {{ statusLabel(invoice.status) }}
                </span>
              </td>
              <td class="text-center">{{ invoice.log }}</td>
              <td class="text-center">{{ invoice.attempts }}</td>
              <td class="text-center" nowrap>{{ invoice.created_at | datetimeUtcToBr }}</td>
            </tr>
            <tr v-if="isExpanded(invoice.id)" :key="'detail' + invoice.id" class="detail-row">
              <td :colspan="10" class="p-0">
                <div class="p-3 text-left detail-box">
                  <p>
                    <strong>Cliente:</strong>
                    {{
                      invoice.customer && invoice.customer.customerable
                        ? invoice.customer.customerable.co_name
                        : '-'
                    }}
                  </p>
                  <p>
                    <strong>Documento:</strong>
                    {{
                      invoice.customer && invoice.customer.documents
                        ? invoice.customer.documents.value
                        : '-'
                    }}
                  </p>
                  <p>
                    <strong>Primeira tentativa:</strong>
                    {{ invoice.first_attempt_at | datetimeUtcToBr }}
                  </p>

                  <p v-if="!attempts[invoice.id]">Carregando tentativas...</p>
                  <table v-else class="table table-sm table-bordered bg-white mb-0">
                    <thead>
                      <tr>
                        <th nowrap class="text-center">Data</th>
                        <th nowrap class="text-center">Enviado Por</th>
                        <th nowrap class="text-center">Status</th>
                        <th nowrap class="text-center">Rota (Omie)</th>
                        <th nowrap class="text-center">Log</th>
                      </tr>
                    </thead>
                    <tbody>
                      <template v-for="(attempt, index) in attempts[invoice.id]">
                        <tr
                          :key="'attempt' + invoice.id + '-' + index"
                          :class="{ 'clickable pointer': attempt.request_body }"
                          @click="toggleAttemptBody(invoice.id, index)"
                        >
                          <td class="text-center" nowrap>
                            {{ attempt.created_at | datetimeUtcToBr }}
                          </td>
                          <td class="text-center">{{ attempt.username || '-' }}</td>
                          <td class="text-center">
                            <span class="badge" :class="statusBadge(attempt.status)">
                              {{ statusLabel(attempt.status) }}
                            </span>
                          </td>
                          <td class="text-center">{{ attempt.call || '-' }}</td>
                          <td class="text-left">
                            {{ attempt.log }}
                            <div v-if="attempt.emails_sended" class="text-muted small">
                              Enviado para: {{ attempt.emails_sended }}
                            </div>
                          </td>
                        </tr>
                        <tr
                          v-if="isAttemptBodyOpen(invoice.id, index)"
                          :key="'attemptBody' + invoice.id + '-' + index"
                        >
                          <td :colspan="5">
                            <p class="mb-1"><strong>Body enviado na requisição:</strong></p>
                            <pre class="detail-pre">{{ formatBody(attempt.request_body) }}</pre>
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
    <PaginatorBottom
      :from="data.from"
      :to="data.to"
      :total="data.total"
      :current_page="data.current_page"
      :last_page="data.last_page"
      @setPage="setPage"
    />
  </div>
</template>

<script>
import { returnMessageFormMixin } from '@/mixins/returnMessageFormMixin';
import { omieAlertsMixin } from '@/mixins/omieAlertsMixin';
import { baseApiUrl } from '@/global';
import PaginatorBottom from '@/components/template/paginator/Bottom.vue';
import axios from 'axios';

const STATUS = {
  1: { label: 'Sucesso', badge: 'badge-success' },
  2: { label: 'Erro', badge: 'badge-danger' },
  6: { label: 'Aguardando faturamento', badge: 'badge-warning' },
  7: { label: 'Aguardando NFS-e', badge: 'badge-warning' },
};

// Limite de tentativas carregadas ao expandir uma fatura.
const MAX_ATTEMPTS = 100;

export default {
  mixins: [returnMessageFormMixin, omieAlertsMixin],
  name: 'OmieSendEmailLogHistory',
  components: { PaginatorBottom },
  data() {
    return {
      data: {},
      page: 1,
      status: '2',
      expanded: {},
      attempts: {},
      openAttemptBodies: {},
    };
  },
  methods: {
    getDatas() {
      const url = `${baseApiUrl}/v1/audits/omie-email-send-log?grouped=1&page=${this.page}&status=${this.status}`;
      axios(url).then((res) => {
        this.data = res.data;
        this.expanded = {};
        this.attempts = {};
        this.openAttemptBodies = {};
      });
    },
    getAttempts(invoiceId) {
      const url = `${baseApiUrl}/v1/audits/omie-email-send-log?invoiceId=${invoiceId}&amount=${MAX_ATTEMPTS}`;
      axios(url).then((res) => {
        this.$set(this.attempts, invoiceId, res.data.data);
      });
    },
    toggleInvoice(invoiceId) {
      const expand = !this.isExpanded(invoiceId);
      this.$set(this.expanded, invoiceId, expand);
      if (expand && !this.attempts[invoiceId]) {
        this.getAttempts(invoiceId);
      }
    },
    isExpanded(invoiceId) {
      return !!this.expanded[invoiceId];
    },
    toggleAttemptBody(invoiceId, index) {
      const key = invoiceId + '-' + index;
      this.$set(this.openAttemptBodies, key, !this.openAttemptBodies[key]);
    },
    isAttemptBodyOpen(invoiceId, index) {
      return !!this.openAttemptBodies[invoiceId + '-' + index];
    },
    statusLabel(status) {
      return STATUS[status] ? STATUS[status].label : status || '-';
    },
    statusBadge(status) {
      return STATUS[status] ? STATUS[status].badge : 'badge-secondary';
    },
    setPage(page) {
      this.page = page;
      this.getDatas();
    },
    onFilterChange() {
      this.page = 1;
      this.getDatas();
    },
    markAsSeen() {
      this.markOmieLogsSeen('email');
    },
    formatBody(body) {
      if (!body) return 'Não disponível';
      try {
        return JSON.stringify(JSON.parse(body), null, 2);
      } catch (e) {
        return body;
      }
    },
  },
  beforeMount() {
    this.getDatas();
  },
  computed: {},
};
</script>

<style scoped>
.detail-box {
  background-color: #f7f7f9;
}
.detail-pre {
  white-space: pre-wrap;
  word-break: break-all;
  max-height: 300px;
  overflow: auto;
  background-color: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 10px;
  font-size: 12px;
  margin: 0;
}
</style>
